/** @format */
import angular from 'angular';

export const courseUnitNameAndCodeModule = 'sis-components.courseUnit.courseUnitNameAndCode';

const template = `<span ng-if="$ctrl.courseUnit">
  <button type="button" class="link-button" ng-click="$ctrl.onClick({courseUnit: $ctrl.courseUnit})" aria-label="{{$ctrl.courseUnit.code}} {{$ctrl.courseUnit.name | localizedString}} {{'ARIA_LABEL.OPEN_INFO' | translate}}">
    <sis-icon icon="brochure"></sis-icon><span>{{$ctrl.courseUnit.code}}</span>
  </button>
  <span>{{$ctrl.courseUnit.name | localizedString}}</span>
</span>`;

angular.module(courseUnitNameAndCodeModule, []).component('courseUnitNameAndCode', {
    template,
    bindings: {
        courseUnit: '<',
        onClick: '&',
    },
});
